import React, { useState } from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import ReactGA from 'react-ga'
import smartlookClient from 'smartlook-client'

import UserApp from 'UserApp'
import ContactApp from 'ContactApp'
import { SENTRY_DSN, GOOGLE_ANALYTICS, SMARTLOOK_KEY, VERSION } from 'config'
import { ColorContext } from 'ColorContext'

import 'stylesheets/reset.scss'
import 'stylesheets/base.scss'
import 'react-datepicker/dist/react-datepicker.css'

function is401Error(event: Sentry.Event, hint: Sentry.EventHint): boolean {
  const ex = hint?.originalException
  if (ex && typeof ex === 'object' && 'response' in ex) {
    const res = (ex as { response?: { status?: number } }).response
    if (res?.status === 401) return true
  }
  const msg = event.message ?? (ex instanceof Error ? ex.message : String(ex ?? ''))
  return typeof msg === 'string' && (msg.includes('401') || msg.includes('Unauthorized'))
}

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: VERSION,
    sendDefaultPii: true,
    ignoreErrors: ['Network Error', 'Request failed with status code 401', 'Unauthorized', 'Failed to load Stripe.js'],
    beforeSend(event, hint) {
      if (is401Error(event, hint)) return null
      return event
    },
    integrations: [
      Sentry.replayIntegration({})
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  })
}

if (GOOGLE_ANALYTICS) {
  ReactGA.initialize(GOOGLE_ANALYTICS)
}

if (SMARTLOOK_KEY) {
  smartlookClient.init(SMARTLOOK_KEY)
}

function App() {
  const [color, setColor] = useState(null)

  return (
    <ColorContext.Provider value={{ color, setColor }}>
      <Router>
        <Switch>
          <Route path='/t' component={ContactApp} />
          <Route path='/i' component={ContactApp} />
          <Route path='/pie' component={ContactApp} />
          <Route path='/pip' component={ContactApp} />
          <Route path='/c' component={ContactApp} />
          <Route path='/s' component={ContactApp} />
          <Route path='/' component={UserApp} />
        </Switch>
      </Router>
    </ColorContext.Provider>
  )
}

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)
  root.render(
    //strictMode was turned off so that useEffect doesnt run twice
    // <React.StrictMode>
      <App />
    // </React.StrictMode>,
  )
}
